import React from 'react';
import '../App.css';

type MiniButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>;

const MiniButton = React.forwardRef<HTMLButtonElement, MiniButtonProps>(
  ({ className, type = 'button', children, ...rest }, ref) => {
    const combinedClassName = ['mini-button', className].filter(Boolean).join(' ');

    return (
      <button
        ref={ref}
        type={type}
        className={combinedClassName}
        style={{ width: '34px', height: '34px', flex: '0 0 34px' }}
        {...rest}
      >
        {children}
      </button>
    );
  },
);

MiniButton.displayName = 'MiniButton';

export default MiniButton;
